import merge from 'lodash/merge';

import baseConfig from './base';
import cmsConfig from './cms_production';
import { LocalConfig } from './specs';

const developmentConfig = (): LocalConfig => merge(baseConfig, cmsConfig, {
  aviakassaV2URL: 'https://v2.aviakassa.com',
  aviakassaURL: 'https://www.aviakassa.com',
  apiV4URL: 'https://www.aviakassa.com/api/',
  staticURL: 'https://www.aviakassa.com/s',
  cmsURL: 'https://www.aviakassa.com/cms/',
  cabinetURL: 'https://www.aviakassa.com/',
  cmsAuthToken: 'NF0hK7YLPWydigAfJ',
  cmsURL_SSR: 'http://rc-ti.cms.ak.ti/',

  metricsTracking: {
    googleAnalytics: false,
    yandexMetrics: true,
    mindboxMetrics: true,
  },

  YM_TrackingID: '7972282',
  GA_TrackingID: 'UA-24277344-1',

  app: {
    trackingEnable: true,
  },

  addProvisionalHeaders: false,

  headers: {
    'Client-Host': 'seo.aviakassa.com',
  },
});

export default developmentConfig;
